/* Rotate Objects */
var objectRotate360 = document.getElementsByClassName("rotate360");
window.addEventListener("scroll", function() {
    for (let i = 0; i < objectRotate360.length; i++) {
      objectRotate360[i].style.transform = "rotate("+Math.round(window.pageYOffset/4)+"deg)";
    }
});

window.onload = function () {
    lax.init()

    AOS.init();

    // Add a driver that we use to control our animations
    lax.addDriver('scrollY', function () {
      return window.scrollY
    })
}

document.addEventListener("DOMContentLoaded", () => {
  console.log("READY");
  document.querySelectorAll('.slideshow .swiper a').forEach(function(element) {
    console.log(element);
    element.addEventListener('click', function() {
      console.log("CLICK");
      window.location.href = this.getAttribute('href');
    });
  });

  var swiperWrapper = document.querySelector('.slideshow__carousel a');
  swiperWrapper.addEventListener('click', function(event) {
    console.log("MOUSE CLICK");
    console.log(event);
      if (event.target.tagName === 'A') {
          console.log("CLICKED");
      }
  });
  
  // var selectors$j = {
  // slide: "[data-slide]",
  // swiper: ".swiper",
  // navigationPrev: ".slideshow-navigation__navigation-button--previous",
  // navigationNext: ".slideshow-navigation__navigation-button--next",
  // navigationDots: ".slideshow-navigation__dots",
  // navigationDot: ".slideshow-navigation__dot",
  // navigationLoader: ".slideshow-navigation__dot-loader",
  // activeDot: "slideshow-navigation__dot--active",
  // animatableItems: ".animation--section-blocks > *"
  // };

  // let slideshowContainer = document.querySelector(selectors$j.swiper, 0);
  // if (slideshowContainer !== 0) {
  //   console.log("SLIDER IS EXIST");
  //   let element = document.querySelector('.slideshow__carousel', 0);
  //   element.params.preventClicks = false;
  //   element.params.allowTouchMove = true;
  //   element.update();
  // }
  
});
